<router-outlet></router-outlet>

<app-bruit-izy *ngIf="displayBruitIo"></app-bruit-izy>
